<template>
  <div class="system-layout-container app-theme">
    <!-- Sidebar -->
    <div class="sidebar" :class="{ 'sidebar-collapsed': isSidebarCollapsed }">
      <!-- 側邊欄的按鈕部分 -->
      <div class="logo-container">
        <img src="@/assets/Image/Logo.png" alt="Logo" class="logo" />
        <!-- 只在展開狀態時顯示收起按鈕 -->
        <button
          class="toggle-btn"
          @click="toggleSidebar($event)"
          v-if="!isSidebarCollapsed"
        >
          <i class="fas fa-chevron-left"></i>
        </button>
      </div>

      <div class="menu-container">
        <router-link
          to="/systemdashboard"
          class="menu-item"
          :class="{ active: isMenuActive('/systemdashboard') }"
          exact
        >
          <i class="fas fa-tachometer-alt"></i>
          <span v-if="!isSidebarCollapsed">儀表板</span>
        </router-link>

        <!-- 商家管理下拉項目 -->
        <div class="menu-dropdown">
          <div
            class="menu-item"
            @click="toggleDropdown('store')"
            :class="{ active: isDropdownActive('store') }"
          >
            <i class="fas fa-store"></i>
            <span v-if="!isSidebarCollapsed">商家管理</span>
            <i
              v-if="!isSidebarCollapsed"
              class="fas"
              :class="dropdowns.store ? 'fa-chevron-down' : 'fa-chevron-right'"
            ></i>
          </div>
          <div
            class="dropdown-content"
            v-if="dropdowns.store"
            :class="{ 'dropdown-collapsed': isSidebarCollapsed }"
          >
            <router-link
              to="/systemdashboard/store/info"
              class="submenu-item"
              :class="{ active: isMenuActive('/systemdashboard/store/info') }"
            >
              <i class="fas fa-info-circle"></i>
              <span v-if="!isSidebarCollapsed">商家資訊設定</span>
            </router-link>
            <router-link
              to="/systemdashboard/store/hours"
              class="submenu-item"
              :class="{
                active: isMenuActive('/systemdashboard/store/hours'),
              }"
            >
              <i class="fas fa-clock"></i>
              <span v-if="!isSidebarCollapsed">營業時間設定</span>
            </router-link>
            <router-link
              to="/systemdashboard/store/cloudorder"
              class="submenu-item"
              :class="{ active: isMenuActive('/systemdashboard/store/cloudorder') }"
            >
              <i class="fa-solid fa-cloud"></i>
              <span v-if="!isSidebarCollapsed">雲端點餐設定</span>
            </router-link>
          </div>
        </div>

        <!-- 菜單管理下拉項目 -->
        <div class="menu-dropdown">
          <div
            class="menu-item"
            @click="toggleDropdown('menu')"
            :class="{ active: isDropdownActive('menu') }"
          >
            <i class="fas fa-utensils"></i>
            <!-- 🍽️ 菜單 icon -->
            <span v-if="!isSidebarCollapsed">菜單管理</span>
            <i
              v-if="!isSidebarCollapsed"
              class="fas"
              :class="dropdowns.menu ? 'fa-chevron-down' : 'fa-chevron-right'"
            ></i>
          </div>

          <div
            class="dropdown-content"
            v-if="dropdowns.menu"
            :class="{ 'dropdown-collapsed': isSidebarCollapsed }"
          >
            <router-link
              to="/systemdashboard/menu/item"
              class="submenu-item"
              :class="{ active: isMenuActive('/systemdashboard/menu/item') }"
            >
              <i class="fas fa-hamburger"></i>
              <span v-if="!isSidebarCollapsed">商品項目管理</span>
            </router-link>
            <router-link
              to="/systemdashboard/menu/itemaddons"
              class="submenu-item"
              :class="{
                active: isMenuActive('/systemdashboard/menu/itemaddons'),
              }"
            >
              <i class="fas fa-puzzle-piece"></i>
              <span v-if="!isSidebarCollapsed">商品加料管理</span>
            </router-link>

            <!-- 第二版 -->
            <!-- <router-link
              to="/systemdashboard/menu/combo"
              class="submenu-item"
              :class="{
                active: isMenuActive('/systemdashboard/menu/combo'),
              }"
            >
              <i class="fas fa-layer-group"></i>
              <span v-if="!isSidebarCollapsed">套餐組合管理</span>
            </router-link> -->
            
          </div>
        </div>

        <!-- 員工管理下拉項目 -->
        <div class="menu-dropdown">
          <div
            class="menu-item"
            @click="toggleDropdown('employee')"
            :class="{ active: isDropdownActive('employee') }"
          >
            <i class="fas fa-user-cog"></i>
            <!-- 🧑‍💼 icon 調整 -->
            <span v-if="!isSidebarCollapsed">員工管理</span>
            <i
              v-if="!isSidebarCollapsed"
              class="fas"
              :class="
                dropdowns.employee ? 'fa-chevron-down' : 'fa-chevron-right'
              "
            ></i>
          </div>

          <div
            class="dropdown-content"
            v-if="dropdowns.employee"
            :class="{ 'dropdown-collapsed': isSidebarCollapsed }"
          >
            <router-link
              to="/systemdashboard/employee/account"
              class="submenu-item"
              :class="{
                active: isMenuActive('/systemdashboard/employee/account'),
              }"
            >
              <i class="fas fa-user"></i>
              <span v-if="!isSidebarCollapsed">員工帳號設定</span>
            </router-link>

            <!-- 第二版 -->
            <!-- <router-link
              to="/systemdashboard/employee/salary"
              class="submenu-item"
              :class="{
                active: isMenuActive('/systemdashboard/employee/salary'),
              }"
            >
              <i class="fa-solid fa-sack-dollar"></i>
              <span v-if="!isSidebarCollapsed">員工薪資計算</span>
            </router-link> -->

            <router-link
              to="/systemdashboard/employee/attendance"
              class="submenu-item"
              :class="{
                active: isMenuActive('/systemdashboard/employee/attendance'),
              }"
            >
              <i class="fas fa-clipboard-list"></i>
              <span v-if="!isSidebarCollapsed">打卡/出勤記錄</span>
            </router-link>
          </div>
        </div>

        <!-- 顧客管理下拉項目 -->
        <div class="menu-dropdown">
          <div
            class="menu-item"
            @click="toggleDropdown('customer')"
            :class="{ active: isDropdownActive('customer') }"
          >
            <i class="fas fa-users"></i>
            <span v-if="!isSidebarCollapsed">顧客管理</span>
            <i
              v-if="!isSidebarCollapsed"
              class="fas"
              :class="
                dropdowns.customer ? 'fa-chevron-down' : 'fa-chevron-right'
              "
            ></i>
          </div>

          <div
            class="dropdown-content"
            v-if="dropdowns.customer"
            :class="{ 'dropdown-collapsed': isSidebarCollapsed }"
          >
            <router-link
              to="/systemdashboard/customer/info"
              class="submenu-item"
              :class="{
                active: isMenuActive('/systemdashboard/customer/info'),
              }"
            >
              <i class="fas fa-id-card"></i>
              <span v-if="!isSidebarCollapsed">顧客基本資料</span>
            </router-link>

            <!-- 第二版 -->
            <!-- <router-link
              to="/systemdashboard/customer/history"
              class="submenu-item"
              :class="{
                active: isMenuActive('/systemdashboard/customer/history'),
              }"
            >
              <i class="fas fa-history"></i>
              <span v-if="!isSidebarCollapsed">消費歷史紀錄</span>
            </router-link> -->

            <router-link
              to="/systemdashboard/customer/coopon"
              class="submenu-item"
              :class="{
                active: isMenuActive('/systemdashboard/customer/coopon'),
              }"
            >
              <i class="fas fa-ticket-alt"></i>
              <span v-if="!isSidebarCollapsed">儲值金/點數/優惠券</span>
            </router-link>
          </div>
        </div>

        <!-- 訂單管理下拉項目 -->
        <div class="menu-dropdown">
          <div
            class="menu-item"
            @click="toggleDropdown('order')"
            :class="{ active: isDropdownActive('order') }"
          >
            <i class="fas fa-receipt"></i>
            <span v-if="!isSidebarCollapsed">訂單管理</span>
            <i
              v-if="!isSidebarCollapsed"
              class="fas"
              :class="dropdowns.order ? 'fa-chevron-down' : 'fa-chevron-right'"
            ></i>
          </div>

          <div
            class="dropdown-content"
            v-if="dropdowns.order"
            :class="{ 'dropdown-collapsed': isSidebarCollapsed }"
          >
            <router-link
              to="/systemdashboard/order/list"
              class="submenu-item"
              :class="{
                active: isMenuActive('/systemdashboard/order/list'),
              }"
            >
              <i class="fas fa-receipt"></i>
              <span v-if="!isSidebarCollapsed">訂單總覽</span>
            </router-link>
          </div>
        </div>

        <!-- 桌位管理下拉項目 -->
        <div class="menu-dropdown">
          <div
            class="menu-item"
            @click="toggleDropdown('table')"
            :class="{ active: isDropdownActive('table') }"
          >
            <i class="fas fa-chair"></i>
            <span v-if="!isSidebarCollapsed">桌位管理</span>
            <i
              v-if="!isSidebarCollapsed"
              class="fas"
              :class="dropdowns.table ? 'fa-chevron-down' : 'fa-chevron-right'"
            ></i>
          </div>

          <div
            class="dropdown-content"
            v-if="dropdowns.table"
            :class="{ 'dropdown-collapsed': isSidebarCollapsed }"
          >
            <router-link
              to="/systemdashboard/table/class"
              class="submenu-item"
              :class="{ active: isMenuActive('/systemdashboard/table/class') }"
            >
              <i class="fas fa-map-marker-alt"></i>
              <span v-if="!isSidebarCollapsed">桌區分類</span>
            </router-link>
            <router-link
              to="/systemdashboard/table/number"
              class="submenu-item"
              :class="{ active: isMenuActive('/systemdashboard/table/number') }"
            >
              <i class="fas fa-th"></i>
              <span v-if="!isSidebarCollapsed">桌位設定</span>
            </router-link>
            <router-link
              to="/systemdashboard/table/state"
              class="submenu-item"
              :class="{ active: isMenuActive('/systemdashboard/table/state') }"
            >
              <i class="fas fa-users"></i>
              <span v-if="!isSidebarCollapsed">桌位狀態與開桌</span>
            </router-link>
          </div>
        </div>

        <!-- 報表管理下拉項目 -->
        <div class="menu-dropdown">
          <div
            class="menu-item"
            @click="toggleDropdown('report')"
            :class="{ active: isDropdownActive('report') }"
          >
            <i class="fas fa-chart-bar"></i>
            <span v-if="!isSidebarCollapsed">報表管理</span>
            <i
              v-if="!isSidebarCollapsed"
              class="fas"
              :class="dropdowns.report ? 'fa-chevron-down' : 'fa-chevron-right'"
            ></i>
          </div>

          <div
            class="dropdown-content"
            v-if="dropdowns.report"
            :class="{ 'dropdown-collapsed': isSidebarCollapsed }"
          >
            <router-link
              to="/systemdashboard/data/accounting"
              class="submenu-item"
              :class="{ active: isMenuActive('/systemdashboard/data/accounting') }"
            >
              <i class="fas fa-file-invoice-dollar"></i>
              <span v-if="!isSidebarCollapsed">營業帳務</span>
            </router-link>
            <router-link
              to="/systemdashboard/data/analysis"
              class="submenu-item"
              :class="{ active: isMenuActive('/systemdashboard/data/analysis') }"
            >
              <i class="fas fa-chart-pie"></i>
              <span v-if="!isSidebarCollapsed">營運分析</span>
            </router-link>
          </div>
        </div>

        <!-- 系統管理下拉項目 -->
        <div class="menu-dropdown">
          <div
            class="menu-item"
            @click="toggleDropdown('setting')"
            :class="{ active: isDropdownActive('setting') }"
          >
            <i class="fas fa-cogs"></i>
            <span v-if="!isSidebarCollapsed">系統管理</span>
            <i
              v-if="!isSidebarCollapsed"
              class="fas"
              :class="
                dropdowns.setting ? 'fa-chevron-down' : 'fa-chevron-right'
              "
            ></i>
          </div>

          <div
            class="dropdown-content"
            v-if="dropdowns.setting"
            :class="{ 'dropdown-collapsed': isSidebarCollapsed }"
          >
            <!-- <router-link
              to="/systemdashboard/order/invoice"
              class="submenu-item"
              :class="{
                active: isMenuActive('/systemdashboard/order/invoice'),
              }"
            >
              <i class="fas fa-receipt"></i>
              <span v-if="!isSidebarCollapsed">發票設定</span>
            </router-link> -->

            <!-- 第二版 -->
            <!-- <router-link
              to="/systemdashboard/order/rules"
              class="submenu-item"
              :class="{ active: isMenuActive('/systemdashboard/order/rules') }"
            >
              <i class="fas fa-search-dollar"></i>
              <span v-if="!isSidebarCollapsed">找零規則</span>
            </router-link> -->
            <!-- <router-link
              to="/systemdashboard/settings/log"
              class="submenu-item"
              :class="{ active: isMenuActive('/systemdashboard/settings/log') }"
            >
              <i class="fas fa-clipboard-list"></i>
              <span v-if="!isSidebarCollapsed">日誌管理</span>
            </router-link> -->

            <!-- <router-link
              to="/systemdashboard/settings/auto"
              class="submenu-item"
              :class="{
                active: isMenuActive('/systemdashboard/settings/auto'),
              }"
            >
              <i class="fas fa-random"></i>
              <span v-if="!isSidebarCollapsed">自動分單</span>
            </router-link> -->
            <router-link
              to="/systemdashboard/set/print"
              class="submenu-item"
              :class="{
                active: isMenuActive('/systemdashboard/set/print'),
              }"
            >
              <i class="fas fa-print"></i>
              <span v-if="!isSidebarCollapsed">出單機設定</span>
            </router-link>
            <router-link
              to="/systemdashboard/set/api"
              class="submenu-item"
              :class="{ active: isMenuActive('/systemdashboard/set/api') }"
            >
              <i class="fas fa-plug"></i>
              <span v-if="!isSidebarCollapsed">API整合設定</span>
            </router-link>
            <router-link
              to="/systemdashboard/set/payment"
              class="submenu-item"
              :class="{
                active: isMenuActive('/systemdashboard/set/payment'),
              }"
            >
              <i class="fas fa-credit-card"></i>
              <span v-if="!isSidebarCollapsed">付款方式管理</span>
            </router-link>
            
            <!-- 第二版 -->
            <!-- <router-link
              to="/systemdashboard/settings/offline"
              class="submenu-item"
              :class="{
                active: isMenuActive('/systemdashboard/settings/offline'),
              }"
            >
              <i class="fas fa-wifi"></i>
              <span v-if="!isSidebarCollapsed">POS離線模式</span>
            </router-link> -->

          </div>
        </div>
      </div>
      <!-- 🔽 回主控台按鈕放在 user-info 之上 -->
      <button @click="goToMainConsole" class="back-button">
        <i class="fas fa-arrow-left"></i>
        <span class="back-text">返回主控台</span>
      </button>
    </div>

    <!-- Main Content -->
    <div
      class="main-content"
      :class="{ 'content-expanded': isSidebarCollapsed }"
    >
      <!-- 為收起狀態添加一個展開按鈕 -->
      <!-- 主內容區域的展開按鈕部分 -->
      <div
        class="sidebar-expander"
        v-if="isSidebarCollapsed"
        @click="toggleSidebar($event)"
      >
        <i class="fas fa-chevron-right"></i>
      </div>

      <div class="top-navbar">
        <div class="breadcrumb">
          <span>{{ currentPath }}</span>
        </div>
        <div class="user-actions">
          <div class="notification">
            <i class="fas fa-bell"></i>
            <span class="badge">3</span>
          </div>
        </div>
      </div>
      <div class="content-wrapper">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script src="@/assets/Js/systemset/systemlayout.js"></script>
<style scoped src="@/assets/Css/app-theme.css"></style>
<style scoped src="@/assets/Css/systemset/systemlayout.css"></style>
